import { STATUS_LABELS, STATUS_COLORS } from "../lib/api";

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${STATUS_COLORS[status] || ""}`}
  >
    {STATUS_LABELS[status] || status}
  </span>
);
